module.exports = __webpack_public_path__ + "static/img/yiliaohuagong.e379131.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/yiliaohuagong.png
// module id = I0+f
// module chunks = 1